export default __webpack_public_path__ + "static/woman-02b1104ce04cdf36f812ed3b4c2a72eb.png";